import React from 'react'

import { Divider, Grid, Typography } from '@material-ui/core'

import useStyles from './styles'

function GasCard({ card, button, largeContent }) {
  const {
    cardClass,
    divider,
    titleClass,
    textClass,
    titleWrapper,
  } = useStyles({ largeContent })
  return (
    <Grid item className={cardClass}>
      <Grid className={titleWrapper}>
        <Typography className={titleClass}>{card.title}</Typography>
      </Grid>
      <Divider className={divider} />
      <Typography className={textClass}>{card.text}</Typography>
      {button && button}
    </Grid>
  )
}

export default GasCard
